export default {
  context: "store",
  botDisplayName: "Hjälprobot",
  botSenderName: "Hjälprobot",
  introMessageText: "Vi använder AI-funktionalitet.<br><a aria-label='Länk till GDPR-information, öppnas i ny flik' target='_blank' href='https://minbutik.ica.se/overview/innehall/9f178ad3-6997-4b52-8e9a-b4fead1e02af'>Läs om GDPR.</a><br><br>Tänk på att inte skriva känsliga uppgifter i chatten.",
  introMessageLinkUrl: "",
  introMessageLinkText: "",
  introMessageLinkAriaLabel: "",
  greeting: {
    userUrl: "",
    messages: ["Hej! Jag är ICAs hjälprobot.", "Vad kan jag hjälpa dig med?"],
  },
  launchIconImageURL: "https://assets.icanet.se/image/upload/v1623865838/digitalassistent/icons/chatbot--red.svg",
  closeChatImageURL: "https://assets.icanet.se/image/upload/v1592490640/digitalassistent/icons/ica-close.svg",
  minimizeChatImageURL: "https://assets.icanet.se/image/upload/v1592490640/digitalassistent/icons/ica-angle-down.svg",
  calloutMessage: "Fråga mig!",
  sendMessageImageURL: "https://assets.icanet.se/image/upload/digitalassistent/icons/send.svg",
  uploadImageURL: "",
  botAvatarImageURL: 'https://assets.icanet.se/image/upload/v1623865838/digitalassistent/icons/chatbot--red.svg',
  agentAvatarImageURL: 'https://assets.icanet.se/image/upload/v1605706331/digitalassistent/icons/twc-agent.svg',
  visibleBotAvatar: false,
  visibleLaunchIcon: true,
  enabledCallout: true,
  additionalData: {}, // Sent to the backend with each message via the 'context' request field
  shouldShowChatBubble: (url: string): boolean => {
    return (
      (url.includes("minbutik") && url.includes("hjalp")) ||
      (url.includes("minbutik") && url.includes("overview"))
    );
  }
}